import React, { useState, useRef, useEffect } from 'react';
import { useHistory, useLocation, Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Box,
  Divider,
  Card,
  CardContent,
  Grid,
  MenuItem,
  Select
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  KeyboardArrowDown,
  Remove as RemoveIcon,
  Search as SearchIcon
} from '@material-ui/icons';
import { toast } from "react-toastify";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { set_cart_items } from "../../../redux/actions/CartAction";
import WebsiteHeader from '../../header/2025/WebsiteHeader';
import '../../../assets/styles/component/customer/Bulk/BulkOrderPage.scss';
import img from '../../../assets/images/Products_Images/2cd43b_0edde190f9eb4ffbb669f6de80034d54_mv2_d_1280_1230_s_2.png'
import img1 from '../../../assets/images/Products_Images/2cd43b_1253868455ff42ef97513b70d65a3f21_mv2.png'
import img2 from '../../../assets/images/Products_Images/2cd43b_3db08e46b877415c8de6bb208c9d05d1_mv2.png'
import img3 from '../../../assets/images/Products_Images/2cd43b_8cde352199ec41958100ae808bea9c51_mv2.png'
import img4 from '../../../assets/images/Products_Images/2cd43b_e1762ed5d54a431b868a924379c3e059_mv2.png'
import img5 from '../../../assets/images/Products_Images/2cd43b_a4430f72c31e4fbe82d1dfe5be11ff8e_mv2.png'
import { apiJson } from '../../../Api';

const BulkOrderPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  let message = "";
  const searchParams = new URLSearchParams(location.search);
  const page = parseInt(searchParams.get("page")) || 1;

  const [products, setProducts] = useState([]);
  const [pagination, setPagination] = useState(null);

  const [cart, setCart] = useState([]);
  const [coupon_code, setCouponCode] = useState("");
  const [searchTerm, setSearchTerm] = useState(searchParams.get("q") || "");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchParams.get("q") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedQuantities, setSelectedQuantities] = useState({});
  const [productsPerPage, setProductsPerPage] = useState(5);
  const [productList, setProductList] = useState(products);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const filteredProducts = productList.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.sku.includes(searchTerm) ||
    product.selectedVariant.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    getProducts(page || 1, 5, searchTerm);
  }, [location.search]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // Call API when debounced value changes
  useEffect(() => {
    // if (debouncedSearchTerm !== '') {
    getProducts(page || 1, 5, debouncedSearchTerm);
    // }
  }, [debouncedSearchTerm]);

  const getProducts = (page, records_per_page, search) => {
    setLoading(true);
    apiJson
      .bulkOrders.getProducts(props.countryId, page, records_per_page, search)
      .then(response => {
        if (response.success) {
          response.data.products?.map(product => {
            product.variants?.map(variant => {
              variant.isSelected = true;
              variant.quantityToAdd = 1;
            });
          });
          setProducts(response.data.products);
          setPagination(response.data.pagination);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handlePageChange = (event, value) => {
    history.push(
      "/" +
      props.countryUrl +
      "-" +
      props.language +
      "/bulk-orders?page=" + value
    );
  }

  const handleQuantityChange = (product_id, variant_id, value) => {
    let temp_products = Object.assign([], products);

    temp_products?.map(product => {
      if (product.id == product_id) {
        product.variants?.map(variant => {
          if (variant.id == variant_id) {
            variant.quantityToAdd = value;
          }
        });
      }
    });

    setProducts(temp_products);
  };

  const handleVariantChange = (product_id, variant_id) => {
    let temp_products = Object.assign([], products);

    temp_products?.map(product => {
      if (product.id == product_id) {
        product.variants?.map(variant => {
          if (variant.id == variant_id) {
            variant.isSelected = true;
          }
          else {
            variant.isSelected = false;
          }
        });
      }
    });

    setProducts(temp_products);
  };

  const addToCart = (product, variant) => {
    // setCartAdding(true);

    apiJson.cart
      .addToCart(
        // variant.product_type == "wholesale"
        //   ? {
        //     line_item: {
        //       quantity: 1,
        //       orderable_type: 'Variant',
        //       orderable_id: variant.line_item_id,
        //       product_type: 'wholesale',
        //     },
        //   }
        //   : variant.type === "products"
        //     ? 
        {
          line_item: {
            quantity: parseInt(product?.variants.find(variant => variant.isSelected == true).quantityToAdd),
            orderable_type: "Variant",
            orderable_id: product?.variants.find(variant => variant.isSelected == true).id,
            is_assembly_added: false,
            assembly_id: null,
          },
        }
        // : {
        //   line_item: {
        //     orderable_type: "Service",
        //     orderable_id: variant.id,
        //     start_at: new Date(startDate).toString(),
        //     service_type: props.product?.service_type,
        //     ...(props.product?.service_type !== "one_time" && { end_at: new Date(endDate).toString() })
        //   },
        // },
        , props.countryId
      )
      .then((response) => {
        // setCartAdding(false);
        if (response.success) {
          apiJson.cart.getCartItems(props.countryId).then((response) => {
            if (response.success) {
              props.set_cart_items({ cart_items: response.data });
            } else if (!response.status) {
              message = response.message // eslint-disable-line react-hooks/exhaustive-deps
                ? response.message !== ""
                  ? response.message
                  : t("errors.wrong")
                : t("errors.wrong");
              showError();
            } else {
              if (response.status >= 400 && response.status < 500) {
                message = response.message
                  ? response.message
                  : response.errors
                    ? response.errors
                    : t("errors.wrong");
                showError();
              } else {
                message = response.message
                  ? response.message !== ""
                    ? response.message
                    : t("errors.wrong")
                  : t("errors.wrong");
                showError();
              }
            }
          });
          if (
            localStorage.getItem("access_token") ||
            localStorage.getItem("user_key") === response.data.user_key
          ) {
            // props.setShowCartSidebar(true);
          } else {
            localStorage.setItem("user_key", response.data.user_key);
            // props.setShowCartSidebar(true);
          }
        } else if (!response.status) {
          message = t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });
  };

  const updateQuantity = (id, value) => {
    // setUpdatingQuantity(true);
    if (value == 0) {
      removeItemFromCart(id);
    }
    apiJson.cart
      .updateProduct(
        id,
        {
          line_item: {
            quantity: value,
            is_assembly_added: false,
            assembly_id: null,
          },
        },
        props.countryId
      )
      .then((response) => {
        if (response.success) {
          props.set_cart_items({
            cart_items: response.data,
          });
        } else if (!response.status) {
          // qc.current.setCounValue(product.quantity);

          message = t("errors.wrong");
          showError();
        } else {
          // qc.current.setCounValue(product.quantity);

          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }

        // setUpdatingQuantity(false);
      });
  };

  const removeItemFromCart = (id) => {
    // setRemoveItemLoader(true);
    apiJson.cart.removeItem(id, props.countryId).then((response) => {
      if (response.success) {
        props.set_cart_items({
          cart_items: response.data,
        });
        // setRemoveItemLoader(false);
      } else if (!response.status) {
        message = t("errors.wrong");
        showError();
        // setRemoveItemLoader(false);
      } else {
        // setRemoveItemLoader(false);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : t("errors.wrong");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });
  };

  const onCouponChanged = (e) => {
    setCouponCode(e.target.value);
  }

  const addCoupon = () => {
    let coupon = coupon_code;

    // setFlag(true);
    apiJson.cart.addCoupon(coupon, props.countryId).then((response) => {
      // setFlag(false);
      // setShowCoupons(false)
      if (response.success) {
        props.set_cart_items({
          cart_items: response.data,
        });
      } else if (!response.status) {
        message = t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : t("cart-page.wrong-coupon");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });
  };

  const removeCoupon = () => {
    // setFlag(true);
    apiJson.cart.removeCoupon(props.countryId).then((response) => {
      // setFlag(false);
      if (response.success) {
        setCouponCode("");
        props.set_cart_items({
          cart_items: response.data,
        });
      } else if (!response.status) {
        message = t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : t("errors.wrong");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });
  };

  const checkoutBtnClicked = (e) => {
    e.preventDefault();
    if (props.cart_items.line_items?.length > 0) {
      if (props.auth) {
        apiJson
          .select.getDefault()
          .then(resp => {
            if (resp.success) {
              if (resp.data.length > 0) {
                const request = {
                  order: {
                    address_id: resp.data[0].id,
                    is_delivery: 1
                  },
                };

                apiJson.select
                  .varifyAdress(request, props.countryId)
                  .then((response) => {
                    if (response.success) {
                      props.set_cart_items({
                        order: {
                          address: resp.data[0],
                          id: response.data.id,
                          createdAddress: response.data,
                        },
                      });
                      setRedirect({
                        value: true,
                        path:
                          "/" + props.countryUrl + "-" + props.language + "/checkout",
                      });
                    } else if (!response.status) {
                      message = t("errors.wrong");
                      showError();
                    } else {
                      if (response.status >= 400 && response.status < 500) {
                        message = response.message
                          ? response.message
                          : response.errors
                            ? response.errors
                            : t("errors.wrong");
                        showError();
                      } else {
                        message = response.message
                          ? response.message !== ""
                            ? response.message
                            : t("errors.wrong")
                          : t("errors.wrong");
                        showError();
                      }
                    }
                  });
              }
              else {
                props.set_cart_items({
                  order: {
                    address: null,
                    id: null,
                    createdAddress: null,
                  },
                });
                setRedirect({
                  value: true,
                  path:
                    "/" + props.countryUrl + "-" + props.language + "/checkout",
                });
              }
            }
          });
      }
      else {
        props.set_cart_items({
          order: {
            address: null,
            id: null,
            createdAddress: null,
          },
        });
        setRedirect({
          value: true,
          path:
            "/" + props.countryUrl + "-" + props.language + "/checkout",
        });
      }
    } else {
      message = "Please add products to cart";
      showError();
    }
  }

  // const subtotal = props.cart_items.reduce((sum, item) => sum + (item.descPrice * item.qty), 0);

  return (
    <div className='bulk-container'>
      <WebsiteHeader />
      <Box className="bulk-order-container ">
        <h1 className='bulk-heading'>Bulk Order</h1>
        <Grid container spacing={3} className="bulk-order-grid-container">
          {/* Left side - Product List */}
          <Grid item xs={9} md={8.5} className="product-list-container">
            <Card className="product-list-card">
              <CardContent className="product-list-card-content">
                {/* Top Bar with Entries Dropdown and Search */}
                <Box className="flex-between top-bar-container">
                  {/* Entries per page dropdown */}
                  <Box className="flex-align-center entries-dropdown-container">
                    <TextField
                      select
                      value={productsPerPage}
                      onChange={(e) => {
                        getProducts(1, Number(e.target.value), "");
                        setProductsPerPage(Number(e.target.value));
                        // setCurrentPage(1);
                      }}
                      variant="outlined"
                      size="small"
                      className="entries-dropdown"
                      SelectProps={{
                        native: true,
                      }}
                    >
                      {[5, 10, 25, 50, 100].map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </TextField>
                    <Typography variant="body2" className="entries-text">Entries per page</Typography>
                  </Box>

                  {/* Search Bar */}
                  <TextField
                    variant="outlined"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    className="search-bar"
                    size="small"
                  />
                </Box>

                {/* Product Table */}
                <TableContainer component={Paper} className="product-table" elevation={0}>
                  <Table>
                    <TableHead>
                      <TableRow className="table-header-row">
                        <TableCell className="table-header-cell">Image</TableCell>
                        <TableCell className="table-header-cell">SKU</TableCell>
                        <TableCell className="table-header-cell product-title-cell">Product Title</TableCell>
                        <TableCell className="table-header-cell">Brand</TableCell>
                        <TableCell className="table-header-cell">Variant</TableCell>
                        <TableCell className="table-header-cell">Price</TableCell>
                        <TableCell className="table-header-cell">Disc. Price</TableCell>
                        <TableCell className="table-header-cell quantity-cell">Qty</TableCell>
                        <TableCell className="table-header-cell action-cell">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        loading ?
                          <>
                            <TableRow>
                              <TableCell className="table-body-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell product-title-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell quantity-cell">
                                <Skeleton />
                              </TableCell>
                              <TableCell className="table-body-cell action-cell">
                                <Skeleton />
                              </TableCell>
                            </TableRow>
                          </>
                          :
                          products.length > 0 ? (
                            products.map((product, index) => (
                              <TableRow
                                key={product.sku}
                                className={`table-body-row ${index === products.length - 1 ? 'last-row' : ''}`}
                              >
                                <TableCell className="table-body-cell">
                                  <img
                                    src={product.variants?.find(variant => variant.isSelected == true)?.featured_image}
                                    alt={product.name_en + " " + product.variants?.find(variant => variant.isSelected == true)?.name_en}
                                    className="product-image"
                                  />
                                </TableCell>
                                <TableCell className="table-body-cell">{product.variants?.find(variant => variant.isSelected == true)?.sku}</TableCell>
                                <TableCell className="table-body-cell product-title-cell">{product[`name_${props.language}`]}</TableCell>
                                <TableCell className="table-body-cell">{product[`brand_title_${props.language}`]}</TableCell>
                                <TableCell className="table-body-cell">
                                  <Select
                                    value={(product.variants.find(variant => variant.isSelected == true))?.id}
                                    onChange={(e) => handleVariantChange(product.id, e.target.value)}
                                    className="variant-select"
                                    disableUnderline
                                    style={{
                                      border: 'none',
                                      backgroundColor: 'transparent'
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        style: {
                                          marginTop: '5px',
                                          boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
                                        }
                                      }
                                    }}
                                  >
                                    {product.variants.map(variant => (
                                      <MenuItem key={variant.id} value={variant.id}>{variant.name_en}</MenuItem>
                                    ))}
                                  </Select>
                                </TableCell>
                                <TableCell className="table-body-cell">${product.variants?.find(variant => variant.isSelected == true)?.discounted_price}</TableCell>
                                <TableCell className="table-body-cell">${product.variants?.find(variant => variant.isSelected == true)?.discounted_price}</TableCell>
                                <TableCell className="table-body-cell quantity-cell">
                                  <TextField
                                    type="number"
                                    value={product.variants?.find(variant => variant.isSelected == true)?.quantityToAdd}
                                    onChange={(e) => handleQuantityChange(product.id, product.variants?.find(variant => variant.isSelected == true).id, e.target.value)}
                                    // onFocus={(e) => {
                                    //   if (selectedQuantities[product.variants?.[0].sku] === 0 || selectedQuantities[product.variants?.[0].sku] === undefined) {
                                    //     handleQuantityChange(product.variants?.[0].sku, '');
                                    //   }
                                    // }}
                                    // onBlur={(e) => {
                                    //   if (e.target.value === '') {
                                    //     handleQuantityChange(product.variants?.[0].sku, 0);
                                    //   }
                                    // }}
                                    inputProps={{
                                      min: 0,
                                      className: 'quantity-input',
                                      ref: inputRef
                                    }}
                                    variant="outlined"
                                    size="small"
                                    // disabled={product.variants?.[0].quantity === 0}
                                    className="quantity-field"
                                  />
                                </TableCell>
                                <TableCell className="table-body-cell action-cell">
                                  <Button
                                    variant="contained"
                                    color={product.variants?.find(variant => variant.isSelected == true)?.quantity > 0 ? "primary" : "default"}
                                    onClick={() => addToCart(product)}
                                    // disabled={product.variants?.find(variant => variant.isSelected == true)?.quantity <= 0 || (selectedQuantities[product.variants?.find(variant => variant.isSelected == true)?.sku] || 0) <= 0}
                                    size="small"
                                    className={`action-button ${product.variants?.find(variant => variant.isSelected == true)?.quantity > 0 ? 'add-to-cart-button' : 'out-of-stock-button'}`}
                                    style={{
                                      backgroundColor: product.variants?.find(variant => variant.isSelected == true)?.quantity > 0 ? '' : '#f5f5f5'
                                    }}
                                  >
                                    {product.variants?.find(variant => variant.isSelected == true)?.quantity > 0 ? "Add to Cart" : "Out of Stock"}
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow className="no-products-row">
                              <TableCell colSpan={9} className="text-center no-products-cell">
                                No products found matching your search
                              </TableCell>
                            </TableRow>
                          )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Bottom Bar with entries info and pagination */}
                <Box className="flex-between bottom-bar-container">
                  {/* <Typography variant="body2" className="entries-info">
                    Showing {indexOfFirstProduct + 1} to {Math.min(indexOfLastProduct, products.length)} of {filteredProducts.length} entries
                  </Typography> */}

                  {/* {products.length > pagination?.records_per_page && ( */}
                  <Pagination
                    count={pagination?.total_pages}
                    page={pagination?.page}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    className="pagination-container"
                    classes={{
                      root: 'pagination-root',
                      rounded: 'pagination-rounded',
                    }}
                  />
                  {/* )} */}
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right side - Cart Summary */}
          <Grid item xs={3} md={3.5} className="cart-summary-container">
            <Card className="cart-summary-card">
              <CardContent className="cart-summary-content">
                <Typography variant="h6" gutterBottom className="cart-title">
                  Your Cart ({props.cart_items.line_items?.length})
                </Typography>


                <Divider className="summary-divider" />

                {/* Cart Items */}
                <Box className="cart-items-container">
                  {props.cart_items.line_items?.length > 0 ? (
                    props.cart_items.line_items?.map((item) => (
                      <Box key={item.id} className="cart-item">
                        <Grid container spacing={1}>
                          <Grid item xs={3}>
                            <img src={item.orderable.featured_image_resized[0]} alt={`${item.orderable[`product_name_${props.language}`]} ${item.orderable[`name_${props.language}`]}`} className="cart-item-image" />
                          </Grid>
                          <Grid item xs={9}>
                            <Typography variant="body2" className="cart-item-title">
                              {item.orderable[`brand_name_${props.language}`]} {item.name}
                            </Typography>
                            <Typography variant="body2" className="cart-item-variant">
                              {`${item.orderable[`product_name_${props.language}`]} ${item.orderable[`name_${props.language}`]}`}
                            </Typography>
                            <Typography variant="body2" className="cart-item-price">
                              {
                                props.country.toLowerCase() === "saudi arabia"
                                  ? "SAR"
                                  : props.country.toLowerCase() === "united arab emirates"
                                    ? "AED"
                                    : "EGP"
                              }
                              {" "}
                              {item.sale_price}
                            </Typography>
                            {console.log("cart line item", item)}
                            <Box className="flex-align-center quantity-control-container">
                              <IconButton
                                size="small"
                                onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                className="quantity-button"
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography variant="body1" className="quantity-value">
                                {item.quantity}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                className="quantity-button"
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => removeItemFromCart(item.id)}
                                className="delete-button"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                  ) : (
                    <Typography variant="body2" className="empty-cart-message">
                      Your cart is empty
                    </Typography>
                  )}
                </Box>

                {/* Order Summary */}
                {props.cart_items.line_items?.length > 0 && (
                  <>
                    <Divider className="summary-divider" />
                    <Typography variant="subtitle1" gutterBottom className="mt-2 order-summary-title">
                      Order Summary
                    </Typography>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">Subtotal</Typography>
                      <Typography className="summary-value">
                        {
                          props.country.toLowerCase() === "saudi arabia"
                            ? "SAR"
                            : props.country.toLowerCase() === "united arab emirates"
                              ? "AED"
                              : "EGP"
                        }
                        {" "}
                        {props.cart_items?.sub_total}
                      </Typography>
                    </Box>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">Cashback</Typography>
                      <Typography className="summary-value">
                        {
                          props.country.toLowerCase() === "saudi arabia"
                            ? "SAR"
                            : props.country.toLowerCase() === "united arab emirates"
                              ? "AED"
                              : "EGP"
                        }
                        {" "}
                        {props.cart_items?.cashback_amount || 0}
                      </Typography>
                    </Box>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">Please add a Coupon to Apply</Typography>
                      <KeyboardArrowDown className="summary-arrow" />
                    </Box>
                    <Box className='d-flex'>
                      <input
                        type='text'
                        onChange={onCouponChanged}
                        placeholder='Enter coupon code'
                        value={coupon_code}
                        className='form-control'
                      />
                      {
                        props.cart_items.coupon_code ?
                          <button
                            className='apply-btn'
                            onClick={removeCoupon}
                          >REMOVE</button>
                          :
                          <button
                            className='apply-btn'
                            onClick={addCoupon}
                          >APPLY</button>
                      }
                    </Box>
                    <Divider className="summary-divider" />
                    <Box className="flex-between summary-row">
                      <Typography className="summary-label">View Available Offers</Typography>
                      <KeyboardArrowDown className="summary-arrow" />
                    </Box>

                    <Button
                      variant="contained"
                      fullWidth
                      className="checkout-button"
                      disabled={props.cart_items.line_items?.length === 0}
                      onClick={checkoutBtnClicked}
                    >
                      Proceed to Checkout
                    </Button>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      {redirect.value && (
        <Redirect
          push
          to={{
            pathname: redirect.path,
            state: redirect.state,
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.language.language,
  countryUrl: state.language.countryUrl,
  auth: state.auth.isSignedIn,
  country: state.language.country,
  countryId: state.language.countryId,
  cart_items: state.cart.cart_items,
  auth: state.auth.isSignedIn
});

const mapDispatchToProps = { set_cart_items };

export default connect(mapStateToProps, mapDispatchToProps)(BulkOrderPage);